import { AxiosRequestConfig } from 'axios'

export interface AgeAnalysisByLevelParams {
  startDate: string
  endDate: string
  storeId?: number
}

export interface AgeData {
  name: string
  value: number
  proportion: number
  code: string
  averageFrequency?: number
}

export interface AgeAnalysisByLevelData {
  data: AgeData[]
  totalUsers: number
}

export const getAgeAnalysisByLevel = (params: AgeAnalysisByLevelParams): AxiosRequestConfig => ({
  url: '/dashboard/age-analysis-by-level',
  method: 'GET',
  params,
})
